export default {
  EXTRA_BW_SAVER: 'EXTRA_BW_SAVER',
  BW_SAVER: 'BW_SAVER',
  DEFAULT: 'DEFAULT',
};
